module.exports = __webpack_public_path__ + "img/sb.a3e7f739.svg";